
import { defineComponent } from 'vue'
import DOMPurify from 'dompurify'

import config from '@/configs/config'
import { MessageTextModel } from '@/types/Message'

import MessageWrapper from '@/components/pages/chat/messages/MessageWrapper.vue'

export default defineComponent({
  name: 'MessageText',
  props: {
    message: {
      type: MessageTextModel,
      required: true
    }
  },
  components: {
    MessageWrapper
  },
  methods: {
    getSafeHtml (line: string) {
      return DOMPurify.sanitize(line, config.CHAT.DOM_PURIFY)
    }
  }
})
